import { h } from "preact";
import { makeStyles } from "@mui/styles";
import palette from "../../theme/palette";
import typography from "../../theme/typography";
import WhiteLink from "../../theme/WhiteLink";
import { Grid, Box, Typography } from "@mui/material/";

import Logo from "./Logo";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,

		marginLeft: theme.spacing(4),
		marginRight: theme.spacing(4),
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
	footer: {
		//marginTop: theme.spacing(4),
		//marginBottom: theme.spacing(4),
		paddingLeft: theme.spacing(6),
		paddingRight: theme.spacing(6),
		backgroundColor: palette.primary.main,
		borderTopRightRadius: "40px",
		borderTopLeftRadius: "40px",
	},
}));

const FooterLink = ({ txt }) => {
	return;
};

export default function FooterLights() {
	const classes = useStyles();

	return (
		<footer className={classes.footer}>
			<Box
				display="flex"
				//alignItems="flex-start"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				p={1}
				m={1}
				style={{ height: "100%", marginBottom: "0px" }}
			>
				<Box p={1} style={{ width: "100%" }}>
					<Box
						display="flex"
						justifyContent="space-between"
						p={1}
						m={1}
						style={({ width: "100%" }, { padding: "0px" }, { borderBottom: "1px solid white" })}
						alignItems="center"
					>
						<Box p={1}>
							<Logo />
						</Box>
						<Box p={1}>

							{/* <a target="_blank" href="#">
								<svg
									width="30px"
									height="30px"
									xmlns="http://www.w3.org/2000/svg"
									version="1.1"
									class="u-svg-content"
									viewBox="0 0 112 112"
									x="0px"
									y="0px"
									id="svg-a76e"
									fill="#FFFFFF"
								>
									<path d="M75.5,28.8H65.4c-1.5,0-4,0.9-4,4.3v9.4h13.9l-1.5,15.8H61.4v45.1H42.8V58.3h-8.8V42.4h8.8V32.2 c0-7.4,3.4-18.8,18.8-18.8h13.8v15.4H75.5z"></path>
								</svg>
							</a>

							<a target="_blank" href="#">
								<span class="u-icon u-icon-circle u-social-instagram u-social-type-logo u-icon-3">
									<svg
										width="30px"
										height="30px"
										xmlns="http://www.w3.org/2000/svg"
										version="1.1"
										class="u-svg-content"
										viewBox="0 0 112 112"
										x="0px"
										y="0px"
										id="svg-bb09"
										fill="#FFFFFF"
									>
										<path d="M55.9,32.9c-12.8,0-23.2,10.4-23.2,23.2s10.4,23.2,23.2,23.2s23.2-10.4,23.2-23.2S68.7,32.9,55.9,32.9z M55.9,69.4c-7.4,0-13.3-6-13.3-13.3c-0.1-7.4,6-13.3,13.3-13.3s13.3,6,13.3,13.3C69.3,63.5,63.3,69.4,55.9,69.4z"></path>
										<path d="M79.7,26.8c-3,0-5.4,2.5-5.4,5.4s2.5,5.4,5.4,5.4c3,0,5.4-2.5,5.4-5.4S82.7,26.8,79.7,26.8z"></path>
										<path d="M78.2,11H33.5C21,11,10.8,21.3,10.8,33.7v44.7c0,12.6,10.2,22.8,22.7,22.8h44.7c12.6,0,22.7-10.2,22.7-22.7 V33.7C100.8,21.1,90.6,11,78.2,11z M91,78.4c0,7.1-5.8,12.8-12.8,12.8H33.5c-7.1,0-12.8-5.8-12.8-12.8V33.7 c0-7.1,5.8-12.8,12.8-12.8h44.7c7.1,0,12.8,5.8,12.8,12.8V78.4z"></path>
									</svg>
								</span>
							</a>
							<a target="_blank" href="#">
								<span class="u-icon u-icon-circle u-social-linkedin u-social-type-logo u-icon-4">
									<svg
										width="30px"
										height="30px"
										xmlns="http://www.w3.org/2000/svg"
										version="1.1"
										class="u-svg-content"
										viewBox="0 0 112 112"
										x="0px"
										y="0px"
										id="svg-3265"
										fill="#FFFFFF"
									>
										<path d="M33.8,96.8H14.5v-58h19.3V96.8z M24.1,30.9L24.1,30.9c-6.6,0-10.8-4.5-10.8-10.1c0-5.8,4.3-10.1,10.9-10.1 S34.9,15,35.1,20.8C35.1,26.4,30.8,30.9,24.1,30.9z M103.3,96.8H84.1v-31c0-7.8-2.7-13.1-9.8-13.1c-5.3,0-8.5,3.6-9.9,7.1 c-0.6,1.3-0.6,3-0.6,4.8V97H44.5c0,0,0.3-52.6,0-58h19.3v8.2c2.6-3.9,7.2-9.6,17.4-9.6c12.7,0,22.2,8.4,22.2,26.1V96.8z"></path>
									</svg>
								</span>
							</a> */}
						</Box>{" "}
						<Box p={1}>
							<ul style={{ listStyle: "none", margin: "0px" }}>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://www.facebook.com/profile.php?id=61553689936874" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-facebook" style="color: #ffffff;">
									<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"></path>
								</svg></a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://twitter.com/Bkeysworld" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-twitter-x" style="color: white;">
									<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"></path>
								</svg></a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://www.instagram.com/bkeysworld/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-instagram" style="color: white;">
									<path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"></path>
								</svg></a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://www.linkedin.com/company/bkeys/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-linkedin" style="color: white;">
									<path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401m-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4"></path>
								</svg></a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://www.tiktok.com/@bkeys.com" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-tiktok" style="color: white;">
									<path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"></path>
								</svg></a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a href="https://www.youtube.com/@bkeys875" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="bi bi-youtube" style="color: white;">
									<path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408z"></path>
								</svg></a></li>
							</ul>
						</Box>
					</Box>
				</Box>
				<Box p={1} css={{ width: "100%" }}>
					<Box
						display="flex"
						justifyContent="space-between"
						p={1}
						m={1}
						css={({ width: "100%" }, { marginTop: "0px" }, { padding: "0px" })}
						alignItems="flex-start"
					>
						{/* <Box p={1}>
							<WhiteLink display="inline" href="/">
								©Bkeys 2021
							</WhiteLink>
						</Box> */}
						<Box p={1}>
							<ul style={{ listStyle: "none", margin: "0px", color: "white", fontWeight: "600", fontSize: "12px" }}>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a style={{ color: "#FFFFFF" }} href="blog_home.html">Blog</a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a style={{ color: "#FFFFFF" }} href="mentions-legales.html">Mentions légales</a></li>
								<li style={{ display: "inline-block", color: "white", marginRight: "8px" }}><a style={{ color: "#FFFFFF" }} href="cgu.html">CGU</a></li></ul>
							{/* <WhiteLink display="inline" href="/cgv">
								Blog
							</WhiteLink>*/}
							{/* <WhiteLink display="inline" href="/blog">
								Blog
							</WhiteLink>
							<WhiteLink display="inline" href="/cgu">
								CGU
							</WhiteLink>
							<WhiteLink display="inline" href="/mentions-legales">
								Mentions légales
							</WhiteLink> */}
							{/* <WhiteLink display="inline" href="/contact">
								App
							</WhiteLink> */}
							{/* <WhiteLink display="inline" href="/contact">
								Contactez-nous :)
							</WhiteLink> */}
						</Box>
						{/* <Box p={1}>
							<Grid container>
								<Grid item xs={6}>
									{" "}
									<WhiteLink href="/" variant="body2">
										Bordeaux
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Paris
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Lille
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Nice
									</WhiteLink>
								</Grid>
								<Grid item xs={6}>
									{" "}
									<WhiteLink href="/" variant="body2">
										Nantes
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Cannes
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Toulouse
									</WhiteLink>
									<WhiteLink href="/" variant="body2">
										Montpellier
									</WhiteLink>
								</Grid>
							</Grid>
						</Box>{" "} */}
					</Box>
				</Box>
			</Box>
		</footer >
	);
}
